import { ReactNode } from 'react';
import {
	IPageLayoutProps,
	PageLayout,
} from '../../../shared/layout/page/PageLayout';
import { PageSections } from '../../../content-sections/ui/PageSections';
import { JumpToSection } from '../../../content-sections/ui/components/JumpToSection';
import PageHeader from '../../../../components/common/header/PageHeader';
import { IPageEntry } from '../../../../contentful/types/IPage';
import { HeaderImageVariants } from '../../../../components/common/header/HeaderImage';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';

export interface IGenericPageProps extends IPageLayoutProps {
	page: IPageEntry;
	backlink?: string;
	backlinkText?: string;
	children?: ReactNode;
	renderContentFirst?: boolean;
	hideHeaderImage?: boolean;
	title?: string;
	withoutFooter?: boolean;
	headerImageVariant?: HeaderImageVariants;
	siteSection?: ISiteSectionEntry;
}

export default function GenericPage({
	page,
	backlink,
	backlinkText,
	children,
	renderContentFirst,
	hideHeaderImage = false,
	title,
	withoutFooter = false,
	headerImageVariant = 'contentPage',
	siteSection,
}: IGenericPageProps) {
	return (
		<PageLayout
			page={page}
			withoutFooter={withoutFooter}
			siteSection={siteSection}
		>
			<PageHeader
				page={page}
				backlink={backlink}
				backlinkText={backlinkText}
				title={title}
				hideHeaderImage={hideHeaderImage}
				siteSectionId={siteSection?.fields.id}
				headerImageVariant={headerImageVariant}
			/>

			{page?.fields?.jumpToSection && (
				<JumpToSection jumpToSection={page.fields.jumpToSection} />
			)}

			{!renderContentFirst && children}

			<div>
				<PageSections sections={page?.fields?.sections} />
			</div>

			{renderContentFirst && children}
		</PageLayout>
	);
}
